import React, { useRef } from 'react'

import './styles.scss'
import { getArrowIcon, getBodyStyle, getClassNames } from './utils'
import Nixi1Spinner from 'components/Nixi1Spinner'

/**
 *
 * @param {boolean} isOpen
 * @param {() => void} toggle
 * @param {boolean} isLoading
 * @param {'primary' | 'dark'} [theme]
 * @param {string} title
 * @param {React.FC} [optionsComponent]
 * @param {React.FC} children
 * @param {number} [height]
 * @param {string} [className]
 * @param {string} [id]
 * @param {(boolean) => void} [onChangeMouseOver]
 * @returns {React.FC}
 */
const CollapsibleContainer = ({ isOpen, toggle, isLoading, theme, title, optionsComponent, children, height, className, id='', onChangeMouseOver, icon }) => {
  const bodyRef = useRef(null)

  return (
    <div className={getClassNames({ isOpen, theme, className })}>
      <div
        className='collapsible-container__header'
        onMouseOver={() => onChangeMouseOver && onChangeMouseOver(true)}
        onMouseLeave={() => onChangeMouseOver && onChangeMouseOver(false)}
      >
        <div className='collapsible-container__title-container' onClick={toggle}>
          {icon ?
            icon
            :  <figure className='collapsible-container__icon collapsible-container__icon--arrow'>
              <img src={getArrowIcon(theme)} alt='Arrow' />
            </figure>
          }
          <p className='collapsible-container__title text-ellipsis'>{title}</p>
          {isLoading ? <Nixi1Spinner width='15px' height='15px' /> : null}
        </div>
        <div className='collapsible-container__options'>{optionsComponent}</div>
      </div>
      <div
        ref={bodyRef}
        className='collapsible-container__body'
        style={getBodyStyle({ isOpen, maxHeight: `${height || bodyRef?.current?.scrollHeight || 0}px` })}
        id={id}
      >
        {children}
      </div>
    </div>
  )
}

export default CollapsibleContainer
